// src/components/auth/UserRegister.js
import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom'; // Not navigating directly from here anymore
import apiClient from '../../apiClient'; // User App's API client

const UserRegister = ({ programId, programName, programShortName, onSwitchToLogin, onRegisterSuccess }) => {
    // const navigate = useNavigate(); // Not used for direct navigation here

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');
    const [algorandAddress, setAlgorandAddress] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!programId) {
            setMessage('Program information is missing.');
            setMessageType('error');
            return;
        }
        setIsLoading(true);
        setMessage('');
        setMessageType('');

        try {
            const payload = { email, password };
            if (username) payload.username = username;
            // Only include algorand_address if it's not empty,
            // backend schema validator for address format will catch issues.
            if (algorandAddress.trim()) payload.algorand_address = algorandAddress.trim();


            await apiClient.post(`/public/programs/${programId}/register`, payload);
            setMessage(`Registration successful for ${programName}! Please login.`);
            setMessageType('success');
            setIsLoading(false);
            if(typeof onRegisterSuccess === 'function') {
                onRegisterSuccess(); // Notify parent, which might switch to login view or show message
            }
        } catch (error) {
            const errorDetail = error.response?.data?.detail || error.message || 'Registration failed.';
            setMessage(Array.isArray(errorDetail) ? errorDetail.map(err => `${err.loc.join('->')}: ${err.msg}`).join('; ') : errorDetail);
            setMessageType('error');
            setIsLoading(false);
        }
    };

    return (
        <div>
            {/* Title is now part of the Modal component itself via props */}
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="register-email">Email:</label>
                    <input type="email" id="register-email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={isLoading} autoComplete="email" />
                </div>
                <div>
                    <label htmlFor="register-password">Password (min 8 chars):</label>
                    <input type="password" id="register-password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} disabled={isLoading} autoComplete="new-password" />
                </div>
                <div>
                    <label htmlFor="register-username">Username (Optional):</label>
                    <input type="text" id="register-username" value={username} onChange={(e) => setUsername(e.target.value)} disabled={isLoading} autoComplete="username" />
                </div>
                <div>
                    <label htmlFor="register-algorandAddress">Algorand Address (Optional):</label>
                    <input 
                        type="text" 
                        id="register-algorandAddress" 
                        value={algorandAddress} 
                        onChange={(e) => setAlgorandAddress(e.target.value)} 
                        disabled={isLoading} 
                        pattern="[A-Z2-7]{58}" 
                        title="Enter a valid 58-character Algorand address if you have one."
                    />
                </div>

                {message && (
                     <div className={`message-container ${messageType === 'success' ? 'success-message' : 'error-message'}`} style={{marginTop: '15px', textAlign:'center'}}>
                        {message}
                    </div>
                )}

                <button type="submit" disabled={isLoading || !email || !password}>
                    {isLoading ? 'Registering...' : 'Register'}
                </button>
            </form>
            <p style={{textAlign: 'center', marginTop: '20px'}}>
                Already have an account for {programName}?{' '}
                <button type="button" onClick={onSwitchToLogin} disabled={isLoading}>
                    Login here
                </button>
            </p>
        </div>
    );
};

export default UserRegister;
